// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Puzzle = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Puzzle = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Puzzle = _exports.Puzzle = function Puzzle(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.0827 10H15.8327C14.9118 10 14.166 10.7458 14.166 11.6667C14.166 12.5875 14.9118 13.3333 15.8327 13.3333H17.0827C17.3127 13.3333 17.4993 13.52 17.4993 13.75V15.8333C17.4993 16.7542 16.7535 17.5 15.8327 17.5H12.916C12.686 17.5 12.4993 17.3133 12.4993 17.0833V15.8333C12.4993 14.9125 11.7535 14.1667 10.8327 14.1667C9.91185 14.1667 9.16602 14.9125 9.16602 15.8333V17.0833C9.16602 17.3133 8.97935 17.5 8.74935 17.5H6.66602C5.74518 17.5 4.99935 16.7542 4.99935 15.8333V13.75C4.99935 13.52 4.81268 13.3333 4.58268 13.3333H3.33268C2.41185 13.3333 1.66602 12.5875 1.66602 11.6667C1.66602 10.7458 2.41185 10 3.33268 10H4.58268C4.81268 10 4.99935 9.81333 4.99935 9.58333V7.5C4.99935 6.57917 5.74518 5.83333 6.66602 5.83333H8.74935C8.97935 5.83333 9.16602 5.64667 9.16602 5.41667V4.16667C9.16602 3.24583 9.91185 2.5 10.8327 2.5C11.7535 2.5 12.4993 3.24583 12.4993 4.16667V5.41667C12.4993 5.64667 12.686 5.83333 12.916 5.83333H15.8327C16.7535 5.83333 17.4993 6.57917 17.4993 7.5V9.58333C17.4993 9.81333 17.3127 10 17.0827 10Z",
      fill: "currentColor"
    }));
  };
});
